import { ClientConfiguration } from "ips/ac/model/odata/generated/IpsCoreModel";
import { ConfigurationDto } from "ips/ac/model/api/WinDoFlow.api.types";


export default class ClientConfigurationMapper {
  public static dtoListToClientConfigurationList(dtoList: ConfigurationDto[]): ClientConfiguration[] {
    if (dtoList === undefined || dtoList.length === 0) {
      return [];
    }

    const clientConfigurations: ClientConfiguration[] = [];
    dtoList.forEach((dto) => {
      clientConfigurations.push(ClientConfigurationMapper.dtoToClientConfiguration(dto));
    });
    return clientConfigurations;
  }

  public static dtoToClientConfiguration(dto: ConfigurationDto): ClientConfiguration {
    if (dto === undefined || dto === null) {
      return undefined;
    }

    return {
      ApplicationDescription: "",
      ApplicationId: "",
      ClientGuid: "",
      ConfigurationDescription: "",
      ConfigurationId: dto.systemId,
      ConfigurationImageName: "",
      ConfigurationTitle: "",
      Counter: 0,
      CreatedOn: "",
      IsActive: 0,
      IsDeleted: 0,
      Sid: dto.sid,
      Type_Id: "",
      Type_Value: "",
      UpdatedOn: "",
      Value: dto.value,
    };
  }
}